import { formatDate } from "../../lib/utils";
import { Milestone } from "../../types/goals";

interface CurrentMilestoneProps {
    milestone: Milestone;
}
const CurrentMilestone = ({ milestone }: CurrentMilestoneProps) => (
    <div>
        <h3 className="text-lg font-medium mb-3 text-gray-900 dark:text-white">
            Hito Actual
            <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
                En progreso
            </span>
        </h3>
        <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg">
            <h4 className="font-medium text-blue-800 dark:text-blue-200">
                {milestone.title}
            </h4>
            <p className="text-sm text-blue-600 dark:text-blue-300 mt-1">
                Fecha de inicio: {formatDate(milestone.startDate)}
            </p>
            <p className="text-sm text-blue-600 dark:text-blue-300">
                Fecha límite: {formatDate(milestone.dueDate)}
            </p>
        </div>
    </div>
);

export default CurrentMilestone;